export default "__VITE_ASSET__28d95d2b__"